export default class SpokenLanguage {
    constructor() {
        this.id = null;
        this.language = { code: null, name: null };
        this.level = null;
        this.invalid = false;
    }

    static fromData(data) {
        if (!data) {
            return;
        }

        const spokenLanguage = new SpokenLanguage();

        spokenLanguage.id = data.id;
        spokenLanguage.language = data.language;
        spokenLanguage.level = data.level;
        spokenLanguage.invalid = false;

        Object.seal();

        return spokenLanguage;
    }

    toData() {
        return {
            id: this.id,
            language: this.language,
            level: this.level,
            invalid: this.invalid,
        };
    }

    isEmptyLanguage() {
        return !this.language.code;
    }

    isEmptyLevel() {
        return !this.level;
    }
}
